module.exports ={
    personInfo: {
    	userinfo:'用户信息',
        head:'头像',
        name:'用户名',
        nameMsg:'请输入姓名',
        username:'姓名',
        usernameMsg:'请输入姓名',
        password:'密码',
        passwordMsg:'请输入用户密码',
        repeatPassword:'重复密码',
        repeatPasswordMsg:'请再次输入用户密码',
        save:'保 存',
        saving:'保存中...',
        validMsg: {       //校验提示信息
            nickName:'请输入姓名',
            password:'请输入用户密码',
            length1:'请输入6-20位密码',
            length2:'请输入6-20位重复密码',
            password2:'请再次输入用户密码',
            passRule:'用户密码不能包含空格',
            passRule2:'用户密码不能包含中文',
            disPw:'两次输入密码不一致'
        },
        hintMsg:{  //数据交互提示信息
            dialogTitle:'修 改',
            sure:'确 定',
            updateSuccess:'修改用户个人信息成功',
            // miss:'缺少请求参数',
            updateFail:'个人信息修改失败',
            queryFail:'查询用户信息失败'
        },
        upload:{
            format:'上传头像图片只能是JPG和PNG格式!',
            size:'图片尺寸必须在200*200以内!',
            fail: '上传失败'

        }

        
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/personInfo.js